import { render, staticRenderFns } from "./MessageLayout.vue?vue&type=template&id=5f4fbd80&"
import script from "./MessageLayout.vue?vue&type=script&lang=js&"
export * from "./MessageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports